import { createIcon } from './createIcon'

export const ItemsIcon = createIcon({
  displayName: 'ItemsIcon',
  viewBox: '0 0 16 16',
  path: [
    <path
      d="M4.11125 4.11119H4.11902M4.11125 1H8.00023C8.39846 1 8.79669 1.15167 9.10003 1.45579L14.5446 6.90036C14.8362 7.19208 15.0001 7.58768 15.0001 8.00017C15.0001 8.41265 14.8362 8.80825 14.5446 9.09997L9.10003 14.5445C8.80832 14.8362 8.41272 15 8.00023 15C7.58774 15 7.19214 14.8362 6.90042 14.5445L1.45585 9.09997C1.31118 8.95571 1.19644 8.78428 1.11823 8.59554C1.04001 8.4068 0.999851 8.20447 1.00006 8.00017V4.11119C1.00006 3.28605 1.32785 2.49471 1.91131 1.91124C2.49477 1.32778 3.28611 1 4.11125 1Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
  ],
})
